[
  {
    "code": "GQ-I-AN",
    "name": "Annobón"
  },
  {
    "code": "GQ-I-BN",
    "name": "Bioko Norte"
  },
  {
    "code": "GQ-I-BS",
    "name": "Bioko Sur"
  },
  {
    "code": "GQ-C-CS",
    "name": "Centro Sur"
  },
  {
    "code": "GQ-C-KN",
    "name": "Kié-Ntem"
  },
  {
    "code": "GQ-C-LI",
    "name": "Litoral"
  },
  {
    "code": "GQ-C-WN",
    "name": "Wele-Nzas"
  }
]